import React from "react";
import { createContext } from "react";

export const ProfileContext = createContext(null);

let store = localStorage.getItem("PROFILE");
store = store ? JSON.parse(store) : false;

export const initialState = {
  user_id: store && store.user_id ? store.user_id : null,
  user_name: store && store.user_name ? store.user_name : "",
  is_auth: store && store.is_auth ? store.is_auth : false,
  is_locked: store && store.is_locked ? store.is_locked : false,
  is_admin: store && store.is_admin ? store.is_admin : false,
  selected: store && store.selected ? store.selected : null,
  finalists: store && store.finalists ? store.finalists : null,
  users: store && store.users ? store.users : [],
};

const RESET = () => localStorage.clear();

export default (state = initialState, action) => {
  switch (action.type) {
    case "ME_GET":
      return {
        ...state,
        user_id: action.payload.user_id,
        user_name: action.payload.user_name,
        users: action.payload.users,
      };
    case "ME_AUTH":
      return {
        ...state,
        is_auth: action.payload.is_auth,
        is_admin: action.payload.is_admin,
        is_locked: action.payload.is_locked,
      };
    case "ME_RELOAD":
      const name = Object.keys(action.payload);

      return {
        ...state,
        [name]: action.payload[name],
      };

    case "ME_RESET":
      RESET();

      return {
        user_id: null,
        user_name: "",
        is_auth: false,
        is_locked: false,
        is_admin: false,
        selected: null,
      };
  }
};
